module.exports = __webpack_public_path__ + "img/Recurso 20@300x.0c0a0837.webp";